'use client'

import { useParams } from 'next/navigation'
import { useEffect } from 'react'

// Import base Noto Sans (already loaded through fonts.ts)
// Import additional script-specific fonts
const fontModules = {
  ar: () => import('@fontsource-variable/noto-sans-arabic'),
  zh: () => import('@fontsource-variable/noto-sans-sc'),
  'zh-TW': () => import('@fontsource-variable/noto-sans-tc'),
  ja: () => import('@fontsource-variable/noto-sans-jp'),
  ko: () => import('@fontsource-variable/noto-sans-kr'),
  he: () => import('@fontsource-variable/noto-sans-hebrew')
  // Add more language-specific fonts as needed
}

type LocaleCodes = keyof typeof fontModules
type ParamsWithLocale = { locale: string }

export default function LocaleFonts() {
  const params = useParams<ParamsWithLocale>()
  const locale = params.locale
  
  useEffect(() => {
    // Get primary language code from locale (e.g., 'zh-TW' -> 'zh')
    const primaryLanguage = locale.split('-')[0] as LocaleCodes
    
    // Check if we have a specific font for the full locale (like zh-TW)
    if (locale in fontModules) {
      fontModules[locale as LocaleCodes]()
      return
    }
    
    // Fall back to the primary language
    if (primaryLanguage in fontModules) {
      fontModules[primaryLanguage]()
    }
    
    // No special treatment needed for Latin-based languages, as they're covered by Noto Sans
  }, [locale])
  
  // This component doesn't render anything
  return null
} 